import React from 'react'

export default class LoggedOutLinks extends React.Component {
  render () {
    return (
      <></>
    )
  }
}
